'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var parseNumber = function parseNumber(string) {
	return parseInt(string, 10) || 0;
};

exports.default = function (node) {
	var buttonQuantity = node && node.props.buttonQuantity ? node.props.buttonQuantity : 0;
	var numbers = Array.from(Array(buttonQuantity).keys()).map(function (index) {
		return index + 1;
	});
	var buttonSettings = numbers.reduce(function (options, number) {
		return options.concat([{
			name: 'button' + number + 'Text',
			inputType: 'text',
			label: 'Text for button ' + number,
			default: ''
		}, node && node.props['button' + number + 'Text'] && {
			name: 'button' + number + 'Url',
			inputType: 'link',
			label: 'URL for button ' + number,
			default: ''
		}]);
	}, []);

	return {
		type: 'BLURB_06',
		name: 'Blurb 06',
		allowedSections: ['main', 'header'],
		disallowedChildren: ['*', '!MEDIA_01', '!VIDEO_01'],
		category: 'Blurbs',
		props: [{
			name: 'heading1',
			inputType: 'text',
			label: 'Title 1',
			default: 'Title'
		}, {
			name: 'heading2',
			inputType: 'text',
			label: 'Heading 2',
			default: ''
		}, {
			name: 'heading3',
			inputType: 'text',
			label: 'Heading 3',
			default: ''
		}, {
			name: 'showLine',
			inputType: 'checkbox',
			label: 'Show line',
			default: false
		}, {
			name: 'showContentOnHover',
			inputType: 'checkbox',
			label: 'Show content on hover',
			default: false
		}, {
			name: 'isForegroundClickable',
			inputType: 'checkbox',
			label: 'Clickable foreground',
			default: true
		}, {
			name: 'buttonQuantity',
			inputType: 'slider',
			label: 'Number of buttons',
			default: 0,
			parse: parseNumber,
			max: 6
		}].concat(buttonSettings).filter(Boolean),
		hiddenProps: [{
			label: 'Content position',
			props: [{
				name: 'vertical',
				inputType: 'select',
				label: 'Vertical position',
				default: 'center',
				values: [{
					label: 'Top',
					value: 'Top'
				}, {
					label: 'Center',
					value: 'Center'
				}, {
					label: 'Bottom',
					value: 'Bottom'
				}]
			}, {
				name: 'horizontal',
				inputType: 'select',
				label: 'Horizontal position',
				default: 'center',
				values: [{
					label: 'Left',
					value: 'Left'
				}, {
					label: 'Center',
					value: 'Center'
				}, {
					label: 'Right',
					value: 'Right'
				}]
			}]
		}, {
			label: 'Content Alignment',
			props: [{
				name: 'align',
				inputType: 'select',
				label: 'Horizontal alignment',
				default: 'center',
				values: [{
					label: 'Left',
					value: 'left'
				}, {
					label: 'Center',
					value: 'center'
				}, {
					label: 'Right',
					value: 'right'
				}]
			}, {
				name: 'marginLeft',
				inputType: 'number',
				label: 'Margin left',
				default: 0,
				parse: parseNumber
			}, {
				name: 'marginRight',
				inputType: 'number',
				label: 'Margin right',
				default: 0,
				parse: parseNumber
			}, {
				name: 'marginTop',
				inputType: 'number',
				label: 'Margin top',
				default: 0,
				parse: parseNumber
			}, {
				name: 'marginBottom',
				inputType: 'number',
				label: 'Margin bottom',
				default: 0,
				parse: parseNumber
			}]
		}, {
			label: 'Advanced settings',
			props: [{
				name: 'class',
				inputType: 'text',
				label: 'CSS-class',
				default: ''
			}]
		}]
	};
};